import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SearchRegular } from "@fluentui/react-icons";
import { CiFilter } from "react-icons/ci";
import {
  Tooltip,
  TableRow,
  TableHeader,
  TableHeaderCell,
  Input,
  Dropdown,
  Option,
  Field,
  useId,
  makeStyles,
  Button,
} from "@fluentui/react-components";
import "./CSS/TableHeaderComponent.css";
const useStyles = makeStyles({
  // these styles wrap the value text within the dropdown button and cause it to truncate
  truncatedText: {
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
export default function TableRowComponent({
  filters,
  onFilterChange,
  callFlows,
  supervisedAgentDetails,
  isAudioPlayed,

  columnSizing_unstable,
}) {
  const [CallId, setCallId] = useState("");
  const [CallerId, setCallerId] = useState("");
  const [AgentName, setAgentName] = useState("");
  const { t } = useTranslation();
  const [dateError, setDateError] = React.useState({
    message: "",
    state: undefined, // "error", "warning", "success"
  });
  const [durationError, setDurationError] = React.useState({
    message: "",
    state: undefined, // "error", "warning", "success"
  });
  const comboId = useId("combo-multi");
  const [options, setOptions] = useState([]);
  const styles = useStyles();

  const [filterVisible, setFilterVisible] = useState({
    recordingScope: false,
    callerId: false,
    agentName: false,
    date: false,
    direction: false,
    duration: false,
    callId: false,
  });
  // Crée les options d'agents en filtrant les éléments invalides
  const agentOptions = supervisedAgentDetails
    ? Object.entries(supervisedAgentDetails)
        .map(([id, { displayName }]) => ({ id, displayName }))
        .filter(({ id, displayName }) => id && displayName) // Exclure si id ou displayName sont vides
    : [];

  // Crée les options de call flows en filtrant les éléments invalides
  const callFlowOptions = callFlows
    ? Object.entries(callFlows)
        .map(([id, { displayName }]) => ({ id, displayName }))
        .filter(({ id, displayName }) => id && displayName) // Exclure si id ou displayName sont vides
    : [];
  useEffect(() => {
    setOptions([...agentOptions, ...callFlowOptions]);
  }, [supervisedAgentDetails, callFlows]);

  //pour faire la traduction du valeur dans le dropdown
  const getTranslatedValue = (value) => {
    switch (value) {
      case "IN":
        return t("IN");
      case "OUT":
        return t("OUT");
      case "":
        return t("ALL");
      default:
        return t("SELECT_DIRECTION");
    }
  };

  // Toggle the visibility of a filter input field
  const toggleFilterVisibility = (column) => {
    setFilterVisible((prev) => ({ ...prev, [column]: !prev[column] }));
  };
  // Handle filter change: update the filters state
  const handleFilterChange = (column, value) => {
    const updatedFilters = { ...filters, [column]: value };
    onFilterChange(updatedFilters);
  };

  //filter recording scope
  const handleOptionSelect = (event, data) => {
    const selectedId = data.optionValue; // ID de l'option sélectionnée

    let updatedRecordingScope = [...filters.recordingScope];

    // Si l'option "All" est sélectionnée/désélectionnée
    if (selectedId === "all") {
      if (updatedRecordingScope.length === options.length) {
        // Si toutes les options sont sélectionnées, on désélectionne tout
        updatedRecordingScope = [];
      } else {
        // Sinon, on sélectionne toutes les options
        updatedRecordingScope = options.map((option) => option.id);
      }
    } else {
      // Gérer la sélection/désélection des autres options
      if (updatedRecordingScope.includes(selectedId)) {
        updatedRecordingScope = updatedRecordingScope.filter(
          (id) => id !== selectedId
        );
      } else {
        updatedRecordingScope.push(selectedId);
      }
    }
    handleFilterChange("recordingScope", updatedRecordingScope);
  };
  //Filter direction
  const handleOptionSelectDirection = (event, data) => {
    const selectedValue = data.optionValue; // Récupère la valeur sélectionnée

    // Si "ALL" est sélectionné, on réinitialise le filtre (valeur vide)
    const directionFilterValue = selectedValue === "ALL" ? "" : selectedValue;

    handleFilterChange("direction", directionFilterValue);
  };

  // Update duration filters
  const handleDurationChange = (field, type, value) => {
    const parsedValue = value === "" ? "" : Math.max(0, parseInt(value) || 0);

    // Récupérer la valeur actuelle
    const currentDuration = filters.duration[field] || 0;
    let minutes = Math.floor(currentDuration / 60);
    let seconds = currentDuration % 60;

    // Mettre à jour soit les minutes, soit les secondes
    if (type === "minutes") {
      minutes = parsedValue;
    } else if (type === "seconds") {
      seconds = parsedValue;
    }

    const updatedValue = (minutes || 0) * 60 + (seconds || 0);
    const updatedDuration = { ...filters.duration, [field]: updatedValue };

    // Vérification d'erreur uniquement si les deux valeurs existent
    if (
      updatedDuration.Min !== "" &&
      updatedDuration.Max !== "" &&
      updatedDuration.Min > updatedDuration.Max
    ) {
      setDurationError({
        message: t("DURATION_MESSAGE_ERROR"),
        state: "error",
      });
    } else {
      setDurationError({ message: "", state: undefined });
    }

    handleFilterChange("duration", updatedDuration);
  };

  // Met à jour les filtres sans validation stricte
  const handleDateChange = (field, value) => {
    let updatedDate = { ...filters.date };
    updatedDate[field] = value;
    handleFilterChange("date", updatedDate);
  };

  // Valide la date lorsque l'utilisateur quitte le champ
  const handleDateBlur = () => {
    const { startDate, endDate } = filters.date;

    if (startDate && endDate) {
      if (startDate > endDate) {
        setDateError({
          message: t("DATE_MESSAGE_ERROR_INF"),
          state: "error",
        });
        return;
      }
    }

    setDateError({ message: "", state: undefined });
  };
  //réglage d'heure
  const formatDateForInput = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <TableHeader>
      <TableRow className="header-container">
        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("Recording")}
          className={` ${isAudioPlayed ? "audio-cell" : ""}`}
        >
          <div className="table-header-title">{t("RECORDING")}</div>
        </TableHeaderCell>

        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("Direction")}
        >
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("DIRECTION")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("direction")}
              />
            </div>

            {filterVisible.direction && (
              <Dropdown
                placeholder={t("SELECT_DIRECTION")}
                value={getTranslatedValue(filters.direction)}
                onOptionSelect={handleOptionSelectDirection}
                className="table-header-dropdown"
                size="small"
              >
                <Option value="IN">{t("IN")}</Option>
                <Option value="OUT">{t("OUT")}</Option>
                <Option value="ALL">{t("ALL")}</Option>
              </Dropdown>
            )}
          </div>
        </TableHeaderCell>

        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("recordingScope")}
        >
          {/* Recording Scope column */}
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("RECORDING_SCOPE")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("recordingScope")}
              />
            </div>
            {filterVisible.recordingScope && (
              <div className={styles.root}>
                <Dropdown
                  size="small"
                  id={comboId}
                  multiselect={true}
                  placeholder={t("ENTER_SCOPE")}
                  disabled={options.length === 0}
                  //truncate the text
                  button={
                    <span className={styles.truncatedText}>
                      {filters.recordingScope.length === options.length
                        ? t("ALL")
                        : filters.recordingScope.map(
                            (id) =>
                              options.find((opt) => opt.id === id)?.displayName
                          )}
                    </span>
                  }
                  //selected All
                  selectedOptions={
                    filters.recordingScope.length === options.length
                      ? ["all", ...filters.recordingScope] // Inclure "all" si toutes les options sont sélectionnées
                      : filters.recordingScope // Sinon, afficher les options sélectionnées
                  }
                  className="table-header-dropdown"
                  onOptionSelect={handleOptionSelect} // Gère la logique de sélection/désélection
                >
                  <Option key="all" value="all">
                    {t("ALL")}
                  </Option>

                  {options.map((option) => (
                    <Option
                      key={option.id}
                      value={option.id}
                      text={option.displayName}
                    >
                      <Tooltip withArrow content={option.displayName}>
                        <span className={styles.truncatedText}>
                          {option.displayName}
                        </span>
                      </Tooltip>
                    </Option>
                  ))}
                </Dropdown>
              </div>
            )}
          </div>
        </TableHeaderCell>
        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("callerId")}
        >
          {/* Caller ID column with filter input */}
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("CALLER_ID")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("callerId")}
              />
            </div>
            {filterVisible.callerId && (
              <div className="flex-gap">
                <Input
                  placeholder={t("ENTER_CALLER_ID")}
                  value={CallerId}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCallerId(value);
                    if (value === "") {
                      handleFilterChange("callerId", "");
                    }
                  }}
                  // onChange={(e) => handleFilterChange("callerId", e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.stopPropagation();
                    }
                  }}
                  className="table-header-input"
                  size="small"
                />
                <Tooltip withArrow content={t("SEARCH")} relationship="label">
                  <Button
                    onClick={() => handleFilterChange("callerId", CallerId)}
                    size="small"
                    icon={<SearchRegular />}
                    className={`search-button ${
                      filters.callerId ? "filled" : ""
                    }`}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </TableHeaderCell>

        <TableHeaderCell
          className="table-header-cell-duration "
          {...columnSizing_unstable.getTableCellProps("duration")}
        >
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("DURATION")}{" "}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("duration")}
              />
            </div>

            {filterVisible.duration && (
              <Field
                validationState={durationError.state}
                validationMessage={
                  durationError.state === "error" ? durationError.message : ""
                }
              >
                <div className="table-header-duration">
                  <Field label={t("FROM")} size="small" className="field" />
                  <Input
                    size="small"
                    type="number"
                    placeholder="Min.."
                    value={
                      filters.duration.Min !== ""
                        ? Math.floor(filters.duration.Min / 60)
                        : ""
                    }
                    onChange={(e) =>
                      handleDurationChange("Min", "minutes", e.target.value)
                    }
                    className="table-header-input-small"
                  />
                  <Input
                    size="small"
                    type="number"
                    placeholder="Sec.."
                    value={
                      filters.duration.Min !== ""
                        ? filters.duration.Min % 60
                        : ""
                    }
                    onChange={(e) =>
                      handleDurationChange("Min", "seconds", e.target.value)
                    }
                    className="table-header-input-small"
                  />
                </div>

                {/* TO Section */}

                <div className="table-header-duration">
                  <Field label={t("TO")} size="small" className="field " />
                  <Input
                    size="small"
                    type="number"
                    placeholder="Min.."
                    value={
                      filters.duration.Max !== ""
                        ? Math.floor(filters.duration.Max / 60)
                        : ""
                    }
                    onChange={(e) =>
                      handleDurationChange("Max", "minutes", e.target.value)
                    }
                    className="table-header-input-small"
                  />
                  <Input
                    size="small"
                    type="number"
                    placeholder="Sec.."
                    value={
                      filters.duration.Max !== ""
                        ? filters.duration.Max % 60
                        : ""
                    }
                    onChange={(e) =>
                      handleDurationChange("Max", "seconds", e.target.value)
                    }
                    className="table-header-input-small"
                  />
                </div>
              </Field>
            )}
          </div>
        </TableHeaderCell>

        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("agentName")}
        >
          {/* Agent Name column with filter input */}
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("AGENT_NAME")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("agentName")}
              />
            </div>
            {filterVisible.agentName && (
              <div className="flex-gap">
                <Input
                  type="text"
                  size="small"
                  placeholder={t("ENTER_NAME")}
                  value={AgentName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAgentName(value);
                    if (value === "") {
                      handleFilterChange("agentName", "");
                    }
                  }}
                  //onChange={(e) => handleFilterChange("agentName", e.target.value) }
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.stopPropagation();
                    }
                  }}
                  className="table-header-input"
                />
                <Tooltip withArrow content={t("SEARCH")} relationship="label">
                  <Button
                    onClick={() => handleFilterChange("agentName", AgentName)}
                    size="small"
                    icon={<SearchRegular />}
                    className={`search-button ${
                      filters.agentName ? "filled" : ""
                    }`}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </TableHeaderCell>

        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("date")}
          className={` ${isAudioPlayed ? "date-cell" : ""}`}
        >
          <div className="table-header-cell">
            <div className="table-header-title">
              {t("DATE")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("date")}
              />
            </div>
            {filterVisible.date && (
              <div className="table-header-date-pickers">
                <Field
                  validationState={dateError.state}
                  validationMessage={
                    dateError.state === "error" ? dateError.message : ""
                  }
                >
                  <div className="date-pickers ">
                    <Field className="field" size="small" label={t("FROM")} />
                    <Input
                      placeholder={t("FROM")}
                      type="datetime-local"
                      value={
                        filters.date.startDate
                          ? formatDateForInput(filters.date.startDate)
                          : ""
                      }
                      // Format correct pour les champs datetime-local
                      onChange={(event, data) => {
                        const date = new Date(data.value); // Convertir la valeur en objet Date
                        if (!isNaN(date.getTime())) {
                          handleDateChange("startDate", date.getTime()); // Appeler avec le timestamp
                        } else {
                          console.error("Date invalide !");
                        }
                      }}
                      onBlur={handleDateBlur}
                      className="table-header-date-picker"
                      size="small"
                    />
                  </div>
                  <div className="date-pickers ">
                    <Field className="field" size="small" label={t("TO")} />
                    <Input
                      placeholder={t("TO")}
                      type="datetime-local"
                      value={
                        filters.date.endDate
                          ? formatDateForInput(filters.date.endDate)
                          : ""
                      }
                      // Format correct pour les champs datetime-local
                      onChange={(event, data) => {
                        const date = new Date(data.value); // Convertir la valeur en objet Date
                        if (!isNaN(date.getTime())) {
                          handleDateChange("endDate", date.getTime()); // Appeler avec le timestamp
                        } else {
                          console.error("Date invalide !");
                        }
                      }}
                      onBlur={handleDateBlur}
                      className="table-header-date-picker"
                      size="small"
                    />
                  </div>
                </Field>
              </div>
            )}
          </div>
        </TableHeaderCell>

        <TableHeaderCell
          {...columnSizing_unstable.getTableCellProps("callTrancription")}
        >
          <div className="table-header-title  "> {t("CALL_TRANSCRIPTION")}</div>
        </TableHeaderCell>
        <TableHeaderCell 
        {...columnSizing_unstable.getTableCellProps("callId")}
        >
          {/* Agent Name column with filter input */}
          <div className="table-header-cell">
            <div className="table-header-title ">
              {t("CALL_ID")}
              <CiFilter
                className="filter-icon"
                onClick={() => toggleFilterVisibility("callId")}
              />
            </div>
            {filterVisible.callId && (
              <div className="flex-gap">
                <Input
                  size="small"
                  placeholder={t("ENTER_CALL_ID")}
                  value={CallId}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCallId(value);
                    if (value === "") {
                      handleFilterChange("callId", "");
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.stopPropagation();
                    }
                  }}
                  className="table-header-input"
                />
                <Tooltip withArrow content={t("SEARCH")} relationship="label">
                  <Button
                    onClick={() => handleFilterChange("callId", CallId)}
                    size="small"
                    icon={<SearchRegular />}
                    className={`search-button ${
                      filters.callId ? "filled" : ""
                    }`}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
  );
}
